import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const COMPANY_GROUP_DELETE_RESOURCE = "company-group" as const;

export const useCompanyGroupDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      await alphartisApiAxios.delete(`/v1/${COMPANY_GROUP_DELETE_RESOURCE}/${uuid}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [COMPANY_GROUP_DELETE_RESOURCE],
      });
    },
  });
};
